/* eslint-disable react/react-in-jsx-scope */
const Constants = {
  HEADER: {
    WELCOME: 'Welcome!',
    HEADER_TITLE_DES: 'Rapid Benchmarks',
    HEADER_TITLE_CYBER: 'Outcome-Driven Metrics',
  },
  SUBHEADER: {
    HEADER: 'Rapid Digital Execution Scorecard',
    SUBHEADER_1: 'Benchmark your digital outcomes and understand how you compare to top performers across 5 key digital KPIs taken from Gartner’s full ',
  },
  KPIs: {
    KPI_1: {
      HEADER: 'Digital Customer Engagement',
      SUBHEADER: 'What percentage of registered customers interacts on digital channels at least once a month?',
      TOOLTIP: ['Digital channels include any digital means to interact with customers (e.g., web, app, social media). Customers can be either users of B2B applications or individual B2C customers.',
        <br key="br-1" />, <br key="br-2" />, 'Formula:', <br key="br-3" />,
        'Rolling 12 month average of (total registered users that used any digital channel at least once in the month / total registered users in B2C and B2B segments)'],
      ACTION_LESS: [
        'Develop and champion a dynamic customer engagement (DCE) business case to secure approval and prioritize the investments necessary for implementation.',
        'Build a technology roadmap to support DCE implementation by partnering with IT to assess the current state of technology architecture and data management capabilities against DCE requirements.',
        'Work with customer service and support leaders to conduct a dynamic customer engagement technology readiness audit',
      ],
      ACTION_MORE: [
        'Leverage Gartner’s CX CORE relationship model and select a relationship starting point by analyzing volumes and business impact.',
        'Define desired business outcomes and invest in journey mapping with data and analytics.',
        'Focus on connecting and orchestrating experiences across all channels, rather than just communicating information between channels, to better-tailor interactions to customers’ individual needs and context.',
      ],
      RESEARCH_LESS: [
        {
          name: '2021 Strategic Roadmap for Dynamic Customer Engagement',
          link: '/document-reader/document/3996366?ref=tool_DES_IT',
          code: '3996366',
        },
        {
          name: 'Tool: Dynamic Customer Engagement Technology Readiness Audit',
          link: '/document-reader/document/4003522?ref=tool_DES_IT',
          code: '4003522',
        },
      ],
      RESEARCH_MORE: [
        {
          name: '3 Steps to Accelerate the Dynamic Customer Engagement Journey With CX CORE',
          link: '/document-reader/document/4010940?ref=tool_DES_IT',
          code: '4010940',
        },
        {
          name: 'Case Study: Customer Engagement Engine (Commonwealth Bank of Australia)',
          link: '/document-reader/document/3986038?ref=tool_DES_IT',
          code: '3986038',
        },
      ],
      lowerMargin: 10,
      upperMargin: 60,
      restMargin: 30,
    },
    KPI_2: {
      HEADER: 'Digital Interaction Share',
      SUBHEADER: 'What percentage of all customer interactions with your organization was conducted and completed in digital channels within the last 12 months?',
      TOOLTIP: ['Digital channels include any digital means to interact with B2C and B2B customers (e.g., web, app, social media, IVR). They can include agent-assisted chat. Do not include interactions where the customer abandoned or where a digital interaction shifted to human assistance.',
        <br key="br-4" />, <br key="br-5" />, 'Formula:', <br key="br-6" />,
        'Total number of customer interactions with the organization through digital channels / Total number of customer interactions across all channels in the last 12 months'],
      ACTION_LESS: [
        'Lower the cost of inbound telephone support by proactively offering digital engagement channels with an emphasis on web and mobile modalities. ',
        'Assess the current ability of customer service technology to support digital customer engagement by creating virtual assessment teams comprising customer service and digital experience specialists, with a view to building a technology roadmap for digital engagement.',
      ],
      ACTION_MORE: [
        'Evaluate the potential economic and customer experience impacts of dynamic customer engagement (DCE) by meeting with peers and experts.',
        'Develop and champion the DCE business case to secure approval and prioritize the investments necessary for implementation.',
        'Partner with customer service and support leaders to build a technology roadmap to support DCE implementation, assess the current state of technology architecture and data management capabilities against DCE requirements.',
      ],
      RESEARCH_LESS: [
        {
          name: 'Advance an All-Digital Customer Service Initiative by De-emphasizing Telephone Calls',
          link: '/document-reader/document/4007513?ref=tool_DES_IT',
          code: '4007513',
        },
      ],
      RESEARCH_MORE: [
        {
          name: '2021 Strategic Roadmap for Dynamic Customer Engagement',
          link: '/document-reader/document/3996366?ref=tool_DES_IT',
          code: '3996366',
        },
      ],
      lowerMargin: 10,
      upperMargin: 60,
      restMargin: 30,
    },
    KPI_3: {
      HEADER: 'Fully Digitized Enterprise Transactions',
      SUBHEADER: 'What percentage of your internal transactions is fully digitized?',
      TOOLTIP: ['Digitized enterprise transactions (e.g., supply chain, administrative and functions that are not customer-facing) are fully digitized and orchestrated (e.g., not requiring any nondigitized tasks such as paper-based work, emails or similar nonautomated processes).',
        <br key="br-7" />, <br key="br-8" />, 'Formula:', <br key="br-9" />,
        'Total number of digitized enterprise transactions / Total number of enterprise transactions'],
      ACTION_LESS: [
        'Identify the highest-value automation opportunities by filtering criteria to identify business processes that are suitable for automation and building a decision tree to determine the best-fit automation tool for each opportunity.',
      ],
      ACTION_MORE: [
        'Create a hyperautomation capability map by working with your business peers to identify all capabilities required to achieve task automation, process automation and augmentation goals.',
      ],
      RESEARCH_LESS: [
        {
          name: 'Client Question Video: How Can We Identify High-Value Robotic Process Automation Opportunities?',
          link: '/document-reader/document/4002848?ref=tool_DES_IT',
          code: '4002848',
        },
      ],
      RESEARCH_MORE: [
        {
          name: 'Beyond RPA: Build Your Hyperautomation Technology Portfolio',
          link: '/document-reader/document/4007267?ref=tool_DES_IT',
          code: '4007267',
        },
      ],
      lowerMargin: 20,
      upperMargin: 80,
      restMargin: 50,
    },
    KPI_4: {
      HEADER: 'Critical IT Services Resilience',
      SUBHEADER: 'What percentage of business-critical IT services has not suffered service degradation (i.e., was fully resilient) in the last 12 months?',
      TOOLTIP: ['Relevant service degradation is intended as an issue that caused disruption of the service-level agreements of the business-critical IT services. Business-critical IT services are those vital for the safety and the continuity of the operations whose interruption can cause damage or serious losses and/or impact on the ability to operate.',
        <br key="br-10" />, <br key="br-11" />, 'Formula:', <br key="br-12" />,
        '1 - (Total business-critical IT services that suffered relevant service degradation at least once in the last 12 months / Total business-critical IT services)'],
      ACTION_LESS: [
        'Invest in an organizational resilience program that includes program management, management discipline scope, risk identification and management, and a governance and accountability framework.',
        'Establish a shared definition of business risk and common goals by developing risk management guidelines and selecting projects, such as technical debt reduction, where I&O and security teams should collaborate.',
        'Employ an integrated approach to resilience that incorporates leadership, workforce, composable technologies, relationships and partnerships, adaptive strategy and connected culture',
      ],
      ACTION_MORE: [
        'Rightsize resilience requirements by focusing less on searching for benchmarks or maturity models and more on making it a product owner or executive business decision.',
        'Employ an integrated approach to resilience that incorporates leadership, workforce, composable technologies, relationships and partnerships, adaptive strategy and connected culture.',
      ],
      RESEARCH_LESS: [
        {
          name: 'Building Organizational Resilience Is a Strategic Imperative',
          link: '/document-reader/document/3989336?ref=tool_DES_IT',
          code: '3989336',
        },
        {
          name: 'Executive Programs Report: Combat Pandemic Disruption in the Hybrid Organization With Resilience and Antifragility',
          link: '/document-reader/document/3996365?ref=tool_DES_IT',
          code: '3996365',
        },
      ],
      RESEARCH_MORE: [
        {
          name: 'IT Resilience — 7 Tips for Improving Reliability, Tolerability and Disaster Recovery',
          link: '/document-reader/document/4002927?ref=tool_DES_IT',
          code: '4002927',
        },
        {
          name: 'Executive Programs Report: Combat Pandemic Disruption in the Hybrid Organization With Resilience and Antifragility',
          link: '/document-reader/document/3996365?ref=tool_DES_IT',
          code: '3996365',
        },
      ],
      lowerMargin: 50,
      upperMargin: 98,
      restMargin: 90,
    },
    KPI_5: {
      HEADER: 'Product-Centric Organization Adoption',
      SUBHEADER: 'What percentage of your IT ADM teams is structured and organized around value streams/products?',
      TOOLTIP: ['Product-centric teams are application delivery teams that work in small, agile teams structured and organized around value streams and/or products (as opposed to projects).',
        <br key="br-13" />, <br key="br-14" />, 'Formula:', <br key="br-15" />,
        'Number of application development and maintenance (ADM) teams that are product-centric/Total number of ADM teams in the IT organization.'],
      ACTION_LESS: [
        'Pilot new ways of working at the enterprise level with multidisciplinary business-IT teams accountable for direct strategic outcomes. Use the results of the pilot to design an enterprisewide transformation program and sell the transformation program to senior leaders and the board of directors.',
        'Define a product manager role and other product leadership roles to lead one or more teams and manage investment prioritization decisions.',
      ],
      ACTION_MORE: [
        'Create a clear sense of team ownership and accountability by aligning product boundaries to customers and users, stakeholders, teams and deliverables.',
        'Organize the product portfolio into a hierarchy of products based on business capabilities and customer value or experience.',
        'Establish platform teams to provide commonly used, packaged business capabilities to fusion teams. Assess platform health based on reusability metrics.',
      ],
      RESEARCH_LESS: [
        {
          name: 'Building Product Management Teams in IT and Beyond, Part 1: Structure, Leadership and Roles',
          link: '/document-reader/document/3987433?ref=tool_DES_IT',
          code: '3987433',
        },
        {
          name: '2021 Strategic Roadmap for Becoming a Product-Centric Organization',
          link: '/document-reader/document/4005727?ref=tool_DES_IT',
          code: '4005727',
        },
      ],
      RESEARCH_MORE: [
        {
          name: '4 Principles for Designing Your Product Portfolio for Product-Centric Software Delivery',
          link: '/document-reader/document/3993445?ref=tool_DES_IT',
          code: '3993445',
        },
        {
          name: 'Case Study: Composable Platforms to Foster Reuse (Ally Financial)',
          link: '/document-reader/document/4006132?ref=tool_DES_IT',
          code: '4006132',
        },
      ],
      lowerMargin: 5,
      upperMargin: 60,
      restMargin: 20,
    },
  },
  LABELS: {
    OVERALL_SCORE: 'Overall Score',
    TOP_PRIORITY: 'Your Top 2 Priorities',
    SUGGESTED_ACTION: 'Suggested Actions',
    RECOMMENDED_RESEARCH: 'Recommended Research:',
    DIGITAL_SCORECARD_EXECUTION: 'Digital Execution Scorecard ',
    TAKE_FULL_1: 'For more robust insights and actionable next steps, take the full ',
    TAKE_FULL_2: 'Digital Execution Scorecard. ',
    TAKE_FULL_3: ' You will receive a comprehensive assessment of your digital performance across a broad spectrum of KPIs, compare your performance to others in industry cohorts , and get prioritized next steps across the entire ',
    TAKE_FULL_4: 'Digital Execution Scorecard Framework.',
    FOOTER_TEXT: '© ###YEAR### Gartner, Inc. and/or its affiliates. All rights reserved.',
    YEAR: '###YEAR###',
    ACTIS_KEY_RAPID: 'gaplite-firehose',
    ACTIS_KEY_CYBER: 'cyber-benchmark-firehose',
    INVITATION: 'invitation',
    SELECT: 'Select',
    CYBER: 'cyber',
  },
  BOTTOM_HELPER: [
    {
      text1: 'Gartner’s Digital Execution Scorecard includes cross-industry benchmark data from 1500 global organizations.',
    },
    {
      text1: 'Overall score is calculated by comparing each KPI to top performers (75th percentile), average performers (50th percentile) and low performers (25th percentile). A maximum of 1 point is awarded per KPI. Overall score is the sum of KPI scores.',
    },
    {
      text1: 'The full ',
      text2: 'Digital Execution Scorecard ',
      text3: ' provides a comprehensive set of digital strategy benchmarks to accelerate decision making and drive execution. CIOs can use their Digital Execution Scorecard report to prioritize digital capability investments and focus efforts on their most important objectives',
    },
  ],
  URLs: {
    GARTNER: 'https://www.gartner.com',
    DES_USER_API: '/api/rapid-benchmarks/des/user',
    CYBER_USER_API: '/api/rapid-benchmarks/cyber/user',
    INVITATION_USER_API: '/api/rapid-benchmarks/des/user/invitation',
    ANY_URL: '*',
    BASE_URL: '/',
    RAPID: 'rapid-benchmarks',
    DES: 'rapid-benchmarks/des',
    CYBER_PPTX_DOWNLOAD: 'outcome-driven-metrics/cybersecurity/pptx-download',
    INVITATION: 'rapid-benchmarks/des/invitation',
    LOGOFF: '/api/auth/logout',
    LOGON: '/account/signin',
    DEVELOPER: 'developer.gartner.com',
    CYBER: 'outcome-driven-metrics/cybersecurity',
    CYBER_OLD: 'rapid-benchmarks/cyber',
    DATAHUB_DASHBOARD: '/data-hub/dashboard',
    CYBER_LIST_API: '/api/rapid-benchmarks/user/org',
    CYBER_SUBINDUSTRY_API: '/api/rapid-benchmarks/subindustry?industryId=',
    CYBER_POST_KPI: '/api/rapid-benchmarks/cyber/kpi',
    CYBER_GET_KPI_LIST: '/api/rapid-benchmarks/cyber/kpiList',
    CYBER_MINIMUM_USER_BENCHMARK_API: '/api/rapid-benchmarks/cyber/kpi/benchmark/data/minimal',
    CYBER_KPI_BENCHMARK_API: '/api/rapid-benchmarks/cyber/kpi/benchmark/data',
    CYBER_GET_COHORT: '/api/rapid-benchmarks/cohort',
    CYBER_PPTX_DATA: '/api/rapid-benchmarks/cyber/gap/internal/user/pptData',
    CYBER_RESOURCES: '/api/rapid-benchmarks/cyber/kpi/resources',
    TEAM_MEMBERS: '/api/rapid-benchmarks/invite/team',
    INVITE_TEAM_MEMBERS: '/api/rapid-benchmarks/invite',
    UPDATE_ROLE_TEAM_MEMBER: '/api/rapid-benchmarks/invite/vendor/role/update',
    REMOVE_TEAM_MEMBER: '/api/rapid-benchmarks/invite',
    RESEND_INVITE: '/api/rapid-benchmarks/invite/resend',
    PEER_DISCUSSION: '/api/rapid-benchmarks/cyber/kpi/peerDiscussion?kpiId=',
    OVERALL_RR: '/api/rapid-benchmarks/cyber/kpi/overAllResources',
    DASHBOARD_DETAILS: '/api/rapid-benchmarks/cyber/user/currentDashboards',
  },
  SNACKBAR: {
    SUCCESS: 'success',
    ERROR: 'error',
    WARNING: 'warning',
  },
  FOOTER: [
    {
      label: 'POLICIES',
      url: '/en/about/policies/overview',
    },
    {
      label: 'PRIVACY POLICY',
      url: '/en/about/policies/privacy',
    },
    {
      label: 'TERMS OF USE',
      url: '/en/about/policies/terms-of-use',
    },
    {
      label: 'OMBUDS',
      url: '/en/about/ombuds',
    },
  ],
  VALUES: {
    DEFAULT_VALUE: 0,
    ZERO: '0%',
  },
  MARKS: [
    {
      value: 0,
      label: '0%',
    },
    {
      value: 50,
      label: '50%',
    },
    {
      value: 100,
      label: '100%',
    },
  ],
  INPUT_TYPE: {
    SLIDER: 'isSlider',
    TOOLTIP: 'isTooltip',
    SNACKBAR: 'isSnackbar',
  },
  GUAGE_CHART: {
    TOP_PERFORMERS: 'Top Performer',
    INITIAL_VAL: 0,
    FINAL_VAL: 5,
  },
  AXIS_CHART: {
    VALUES: ['0%', '10%', '20%', '30%', '40%', '50%', '60%', '70%', '80%', '90%', '100%'],
    RESP_VALUES: ['0%', '20%', '40%', '60%', '80%', '100%'],
  },
  ROLES: {
    DES: [
      'gartner_associate',
      'des_core_con',
    ],
    CYBER: [
      'gartner_associate',
      'csvb_fll',
      'csvb_eap',
    ],
  },
  ERROR: {
    PERMISSION_DENIED: '/en/contact/general-contacts',
    ACCESS_DENIED: 'Access Denied',
    RANGE_ERROR: 'Please enter valid values!',
    NONZERO_ERROR: 'You cannot enter zero (0) for this metric. If your intent is to skip this metric, please leave it blank.',
    HOURS_ERROR: 'Note that the measurement unit for this metric is in "hours". Please confirm your entry.',
    TARGET_VALUE_TOO_HIGH_ERROR: 'Note that a lower target means better protection. Please confirm your entry.',
    SUCCESS_ERROR: 'Data saved successfully!',
    CONTACT_US: 'Contact Us',
    WENT_WORNG: 'Something went wrong. Please try again later.',
    LIMIT_EXCEEDED: 'Please enter values up to 7 digits only.',
  },
  BUTTON: {
    SIGN_OUT: 'Sign Out',
    CALCULATE: 'Calculate',
    COMPLETE_FULL: 'Complete Digital Execution Scorecard',
    DOWNLOAD: 'Download',
    SEE_MORE: 'See more',
  },
  INVITATION_DIALOG: {
    TITLE: 'Gartner',
    LABEL: 'Please enter your email ID to continue to Gartner Rapid Digital Execution Scorecard.',
    PLACEHOLDER: 'Enter your email ID',
    NON_BUSINESS_EMAIL_ERROR: 'Only business emails are allowed.',
    CONTINUE: 'Continue',
  },
  ACTIS: {
    GARTNER_ICON: {
      activityAction: 'Gartner_Logo',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Gartner Home logo from header',
      activityValue: 'true',
    },
    ACCOUNT_ICON: {
      activityAction: 'Account_Icon',
      activityCategory: 'Action',
      activityMeta: 'User clicks on Account icon from header',
      activityValue: 'true',
    },
    SIGN_OUT: {
      activityAction: 'Sign_Out',
      activityCategory: 'Action',
      activityMeta: 'User clicks on Sign out option from Account Menu',
      activityValue: 'true',
    },
    TOOLTIP_OPEN: {
      activityCategory: 'Tooltip',
      activityMeta: 'User hovers over info icon present next to KPI name',
    },
    TOOLTIP_CLOSE: {
      activityCategory: 'Tooltip',
      activityMeta: 'User closes the tooltip of KPI name using close icon',
    },
    SLIDER: {
      activityCategory: 'Slider',
      activityMeta: 'User changes the KPI progress using Slider',
    },
    INPUT_FIELD: {
      activityCategory: 'Input_Field',
      activityMeta: 'User changes the KPI progress using Input field',
    },
    CALCULATE: {
      activityAction: 'Calculated_Score',
      activityCategory: 'Action',
    },
    RECOMMENDED_RESEARCH: {
      activityAction: 'Recommended_Research',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Recommended Research link of respective KPI',
    },
    DES_LINK: {
      activityAction: 'Digital_Execution_Scorecard',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Digital Execution Scorecard link',
      activityValue: 'true',
    },
    DESF_OPEN: {
      activityAction: 'Digital_Execution_Scorecard_Framework',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Digital Execution Scorecard Framework link',
    },
    DESF_CLOSE: {
      activityAction: 'Digital_Execution_Scorecard_Framework',
      activityCategory: 'Link',
      activityMeta: 'User clicks on close icon in Digital Execution Scorecard Framework modal',
    },
    CDES: {
      activityAction: 'Complete_Digital_Execution_Scorecard',
      activityCategory: 'Action',
      activityMeta: 'User clicks on Complete Digital Execution Scorecard Button',
      activityValue: 'true',
    },
    KPI_ANALYSIS: {
      activityAction: '10_KPIs_that_correlated_with_top_digital_performance',
      activityCategory: 'Link',
      activityMeta: 'User clicks on 10 KPIs that correlated with top digital performance link from Note section',
      activityValue: 'true',
    },
    POLICIES: {
      activityAction: 'Policies',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Policies link from Footer',
      activityValue: 'true',
    },
    TERMS_OF_USE: {
      activityAction: 'Terms of use',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Terms of use link from Footer',
      activityValue: 'true',
    },
    OMBUDS: {
      activityAction: 'Ombuds',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Ombuds link from Footer',
      activityValue: 'true',
    },
    PRIVACY_POLICY: {
      activityAction: 'Privacy_Policy',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Privacy Policy link from Footer',
      activityValue: 'true',
    },
    PRIVACY_POLICY_OPTIN: {
      activityAction: 'Privacy_Policy',
      activityCategory: 'Link',
      activityMeta: 'User clicks on Privacy Policy link from Opt In Agreement',
      activityValue: 'true',
    },
    LOGIN: {
      activityAction: 'Login',
      activityCategory: 'Login',
      activityMeta: 'User succesfully logged into the App',
      activityValue: 'true',
    },
    ACCESS_DENIED: {
      activityAction: 'Access_Denied',
      activityCategory: 'Error',
      activityValue: 'true',
      activityMeta: 'User not authorised',
    },
    PAGE_NOT_FOUND: {
      activityAction: 'Page_Not_Found',
      activityCategory: 'Error',
      activityMeta: 'User tried to access invalid path',
      activityValue: 'true',
    },
    ERROR_PAGE: {
      activityAction: 'Error_Page',
      activityCategory: 'Error',
      activityMeta: 'User landed on the error page',
      activityValue: 'true',
    },
    DOWNLOAD_IMAGE: {
      activityAction: 'Download_Page',
      activityCategory: 'Action',
      activityMeta: 'User clicks on download page button',
      activityValue: 'true',
    },
    DES_TOOL: {
      activityAction: 'DES_Tool',
      activityCategory: 'Action',
      activityMeta: 'User clicks on See more button from Ready for next level section',
      activityValue: 'true',
    },
    APP_LAUNCHER_OPEN: {
      activityAction: 'Open_App_Launcher',
      activityCategory: 'Action',
      activityMeta: 'User opens the App Launcher',
      activityValue: 'true',
    },
    APP_LAUNCHER_CLOSE: {
      activityAction: 'Close_App_Launcher',
      activityCategory: 'Action',
      activityMeta: 'User closes the App Launcher',
      activityValue: 'true',
    },
  },
  ACCESS_DENIED_ERROR: {
    TITLE: "Sorry, you don't have permission for this page",
    BODY1:
      'Unfortunately, your current subscription doesn’t allow for you to access this content. Contact your Gartner representative for details on how you can gain access.',
    BODY2: '',
    LABEL: 'Go to Gartner Homepage',
  },
  PAGE_NOT_FOUND_ERROR: {
    TITLE: 'Sorry for the inconvenience',
    BODY1: "We're having trouble finding the page you're looking for.",
    BODY2:
      "Please check the page address to make sure it's correct or visit the dashboard and explore from there.",
    LABEL: 'Go to Dashboard',
  },
  DEFAULT_ERROR: {
    COMMON_ERROR_MSG:
      "Sorry, we can't load this right now. Please try again later.",
    TITLE: 'Sorry for the inconvenience',
    BODY1: "We're having trouble loading the page you're looking for.",
    BODY2: 'Please wait and try again in a few minutes.',
    LABEL: 'Refresh Page',
  },
  ERROR_CODE: {
    UNAUTHORIZED: 401,
    PERMISSION_DENIED: 403,
  },
  EVENT_NAME: "CONF-CIO Mar'24",
  LINKS: {
    DIGITAL_SCORECARD: '/document-reader/document/4012567',
    DES_TOOL: 'https://bod.gartner.com/#/myAssessments?gcomlogin=',
  },
  READY: {
    HEADING: 'Ready for the next level?',
    TEXT_1: 'The full ',
    TEXT_2: 'Digital Execution Scorecard ',
    TEXT_3: ' offers clients a more comprehensive assessment of your current digital performance, including benchmark comparisons to industry peers.',
  },
  FULL_STORY_ID: 'o-1SE1PF-na1',
  FS_DES: 'Gaplite-Rapid',
  FS_CYBER: 'Gaplite-Cyber',
  NON_ZERO_KPI_IDS: [1, 2, 12, 13, 15, 16],
  DEFAULT_KPIS: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16],
  KPIS_ID_IDENTIFY: [6, 4, 5],
  KPIS_ID_PROTECT: [12, 10, 7, 11, 16, 15, 13, 8, 14, 3],
  KPIS_ID_RESPOND: [1, 2],
  KPIS_ID_RECOVER: [9],
  PERMISSIONS: {
    MANAGE_TEAM: 'manage-team',
    DOWNLOAD_RESULT: 'download-result',
    EDIT_PEER_COMPARISION_GROUP: 'edit-peer-comparison-group',
  },
  GARTNER_DOMAIN: 'gartner.com',
};

export default Constants;
